



















import Language, { hayawazaLangStorageKey } from "@/common/language";
import { ReloadManager } from "@/common/util/reloadManager";
import System from "@/model/system";
import { vuexStorageKey } from "@/store";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const systemStore = namespace("SystemStore");

@Component({
  name: "Error",
})
export default class Error extends Vue {
  @systemStore.Getter
  getSystem!: System;

  errorMessage = "";
  appVersion = Language.appVersion;
  customerToken = "";

  mounted() {
    this.customerToken = this.getSystem?.customer_token;
    this.errorMessage = this.$route.query.errorMessage as string;
    ReloadManager.load(this.getSystem).stop();
    localStorage.removeItem(vuexStorageKey);
    localStorage.removeItem(hayawazaLangStorageKey);
  }
}
